var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.527484 17.7821L12.4449 29.6998C12.7851 30.04 13.2385 30.2267 13.722 30.2267C14.206 30.2267 14.6591 30.0397 14.9993 29.6998L16.0813 28.6175C16.4213 28.2779 16.6085 27.8242 16.6085 27.3405C16.6085 26.857 16.4213 26.388 16.0813 26.0484L9.12887 19.0806L31.2172 19.0806C32.2131 19.0806 33 18.301 33 17.3048L33 15.7747C33 14.7786 32.2131 13.9203 31.2172 13.9203L9.04999 13.9203L16.0811 6.91365C16.421 6.57345 16.6083 6.13211 16.6083 5.64839C16.6083 5.16519 16.421 4.71742 16.0811 4.37749L14.9991 3.2987C14.6589 2.95851 14.2057 2.77312 13.7217 2.77312C13.2383 2.77312 12.7849 2.96092 12.4447 3.30111L0.527217 15.2186C0.186217 15.5598 -0.00131731 16.0154 2.55028e-05 16.4997C-0.00104638 16.9855 0.186217 17.4414 0.527484 17.7821Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(33 33) rotate(180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.84507150.svg";
export { ForwardRef as ReactComponent };